<template>
  <div class="order-detail-packages">
    <wrld-box :headerTitle="$t('orders.packages')">
      <template v-slot:boxContent>
        <v-data-table
          :headers="headers"
          :items="packages"
          :loading="isFetching"
          :items-per-page-text="$t('data_tables.rows_per_page')"
          :items-per-page="5"
          :no-data-text="$t('data_tables.no_data')"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{props.item.code}}</td>
              <td class="text-right">{{props.item.dimensions| dimensionValue}}</td>
              <td class="text-right">{{props.item.weight | roundValue(1)}}</td>
              <td class="text-center">
                <span v-if="props.item.stuckable">{{$t('orders.yes')}}</span>
                <span v-else>{{$t('orders.no')}}</span>
              </td>
              <td>
                <span v-if="props.item.rotatable">{{$t('orders.yes')}}</span>
                <span v-else>{{$t('orders.no')}}</span>
              </td>
              <td>{{$t('orders.ready')}}</td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </wrld-box>
    <v-row justify="center">
      <v-dialog
        v-model="addPackageDialog"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="headline">New package</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col sm="12">
                  <v-text-field
                    label="Ref*"
                    required
                    v-model="newPackage.code"
                  ></v-text-field>
                </v-col>
                <v-col sm="4">
                  <v-text-field
                    label="Length*"
                    required
                    suffix="cm"
                    type="number"
                    v-model="newPackage.dimensions.length"
                  ></v-text-field>
                </v-col>
                <v-col sm="4">
                  <v-text-field
                    label="Height*"
                    required
                    suffix="cm"
                    type="number"
                    v-model="newPackage.dimensions.height"
                  ></v-text-field>
                </v-col>
                <v-col sm="4">
                  <v-text-field
                    label="Width*"
                    required
                    suffix="cm"
                    type="number"
                    v-model="newPackage.dimensions.width"
                  ></v-text-field>
                </v-col>
                <v-col sm="4">
                  <v-text-field
                    label="Weight*"
                    required
                    suffix="kg"
                    type="number"
                    v-model="newPackage.weight"
                  ></v-text-field>
                </v-col>
                <v-col sm="8" />
                <v-col sm="4">
                  <v-checkbox
                    label="Stuckable"
                    v-model="newPackage.stuckable"
                  ></v-checkbox>
                </v-col>
                <v-col sm="4">
                  <v-checkbox
                    label="Rotatable"
                    v-model="newPackage.rotatable"
                  ></v-checkbox>
                </v-col>

              </v-row>
            </v-container>
            <small>*indicates required field</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="addPackageDialog = false"
            >Close</v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click.prevent="addPackage()"
            >Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'OrderDetailPackages',
  props: {
    packages: {
      type: Array,
      required: true
    },
    isFetching: Boolean
  },
  data () {
    return {
      addPackageDialog: false,
      newPackage: {
        code: '',
        dimensions: {
          width: '',
          height: '',
          length: ''
        },
        weight: '',
        stuckable: true,
        rotatable: true
      },
      headers: [
        { text: this.$i18n.t('orders.ref'), value: 'code', sortable: true },
        { text: this.$i18n.t('orders.dims'), value: 'dims', align: 'right' },
        { text: this.$i18n.t('orders.weight_2'), value: 'weight', align: 'right' },
        { text: this.$i18n.t('orders.stuckable'), value: 'stuckable', align: 'center' },
        { text: this.$i18n.t('orders.rotatable'), value: 'rotatable' },
        { text: this.$i18n.t('orders.status'), value: 'status' }
      ]
    }
  },
  methods: {
    editPackage (pkg) {
      this.newPackage = pkg
      this.addPackageDialog = true
    },
    addPackage () {
      this.addPackageDialog = false
      let pkg = {}
      pkg.code = this.newPackage.code
      pkg.dimensions = {}
      pkg.dimensions.width = Number(this.newPackage.dimensions.width)
      pkg.dimensions.height = Number(this.newPackage.dimensions.height)
      pkg.dimensions.length = Number(this.newPackage.dimensions.length)
      pkg.weight = Number(this.newPackage.weight)
      pkg.stuckable = this.newPackage.stuckable
      pkg.rotatable = this.newPackage.rotatable
      this.newPackage = {
        code: '',
        dimensions: {
          width: '',
          height: '',
          length: ''
        },
        weight: '',
        stuckable: true,
        rotatable: true
      }
      this.$emit('add-package', pkg)
    }
  }
}
</script>
